import axios from 'axios';

/**
 * เครื่อง POS ที่ "คอมเครื่องนี้" ถูกจองไว้เป็น (silver-spoon-api/docs/vat-compliance.md D10)
 *
 * เราเป็น web app — เบราว์เซอร์อ่าน serial เครื่องไม่ได้ ตัวตนของ "เครื่อง" จึงเป็น token
 * ที่ server สุ่มให้ตอนกด "ใช้คอมเครื่องนี้เป็น …" ที่หน้าจัดการสาขา แล้วเก็บไว้ 2 ที่:
 * localStorage ของคอมเครื่องนั้น + คอลัมน์ pos_devices.device_token
 *
 * ต้องเป็น localStorage ไม่ใช่ pinia อย่างเดียว เพราะต้องรอด refresh และปิด/เปิดเบราว์เซอร์
 *
 * interceptor แนบ token ไปกับทุก request ผ่าน **header** ไม่ใช่ body
 * เพราะ API ปฏิเสธ key ที่ไม่รู้จัก (ERROR_KEY_NOT_ALLOWED) — ถ้าใส่ใน payload
 * จะต้องไปเติมกฎที่ middleware ของทุก endpoint
 */
const STORAGE_KEY = 'pos.device';

export function getPosDevice() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null;
  } catch (e) {
    return null;
  }
}

export function setPosDevice(device) {
  // { id, name, rd_device_code, device_token }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(device));
}

export function clearPosDevice() {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * เรียกครั้งเดียวตอนบูตแอป — อ่าน token สดทุก request (ไม่ cache ตอน import)
 * เพราะผู้ใช้กดจองเครื่องกลางทางได้โดยไม่ reload หน้า
 */
export function registerPosDeviceInterceptor() {
  axios.interceptors.request.use((config) => {
    const device = getPosDevice();
    if (device?.device_token) {
      config.headers = config.headers || {};
      config.headers['X-POS-Device-Token'] = device.device_token;
    }
    return config;
  });
}
